export default __webpack_public_path__ + "static/media/allow-safra-7.195a8e6a.png";